// src/context/adminDetailsContext.js
import { createContext } from "react";

const AdminDetails = createContext({
  details: null,
  setDetails: () => {},
  superAdmin: null,
  setSuperAdmin: () => {},
  logout: () => {},
  userType: null, // 'admin' or 'superadmin'
  setUserType: () => {},
});

export default AdminDetails;